module.exports = __webpack_public_path__ + "static/media/18.86b54575.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/18.JPG
// module id = 460
// module chunks = 0